// YBV Brand Intelligence - Profile Data
// This file contains MOCK data for demonstration purposes
// In production, this would be connected to real APIs

export const profiles = {
  pochettino: {
    id: 'pochettino',
    name: 'Mauricio Pochettino',
    role: 'Head Coach',
    organization: 'US Men\'s National Team',
    nationality: 'Argentina',
    previousClubs: ['Tottenham Hotspur', 'Paris Saint-Germain', 'Chelsea'],
    // Profile photo - official asset
    photo: 'https://customer-assets.emergentagent.com/job_724875ab-121b-40d9-b670-59969cd98133/artifacts/78bxmu2n_pochettino.jpeg',
    initials: 'MP',
    
    // Verified Social Profiles (URLs and handles only - follower counts fetched live)
    socialProfiles: {
      instagram: {
        url: 'https://www.instagram.com/pochettino/',
        handle: '@pochettino'
        // followers: FETCHED LIVE from backend - not mocked
      }
      // twitter: No official profile - non-official accounts exist
      // LinkedIn: No official profile
      // TikTok: No official profile - non-official accounts exist
      // YouTube: No official profile
    },
    
    // Platform risk flags
    hasUnofficialProfilesRisk: true,
    unofficialProfilesNote: 'Non-official accounts exist on X/TikTok and may drive narrative outside official control. No official accounts currently managed on these platforms.',
    
    // Core YBV Metrics
    metrics: {
      brandStrength: {
        score: 78,
        direction: 'up',
        confidence: 'High',
        insight: 'Strong global recognition amplified by recent USMNT appointment and consistent media presence.',
        components: {
          globalRecognition: 82,
          mediaPresence: 75,
          digitalFootprint: 71,
          narrativeControl: 84
        }
      },
      reputationStability: {
        score: 71,
        direction: 'stable',
        confidence: 'High',
        insight: 'Maintained professional standing despite Chelsea tenure. Historical track record provides resilience.',
        components: {
          sentimentConsistency: 74,
          crisisResistance: 68,
          narrativeVolatility: 72,
          publicTrust: 70
        }
      },
      commercialAttractiveness: {
        score: 74,
        direction: 'up',
        confidence: 'Medium',
        insight: 'US market entry significantly expands commercial potential. Premium positioning in growing soccer market.',
        components: {
          sponsorAppeal: 76,
          marketDemand: 78,
          endorsementPotential: 72,
          mediaValue: 70
        }
      },
      riskExposure: {
        score: 35,
        direction: 'down',
        confidence: 'Medium',
        insight: 'Lower risk profile than European roles. National team context reduces club-level volatility factors.',
        components: {
          performanceDependency: 42,
          mediaScrutiny: 38,
          contractVulnerability: 28,
          reputationalThreats: 32
        }
      },
      overallIndex: {
        score: 72,
        direction: 'up',
        confidence: 'High',
        insight: 'Strong overall brand position with upward trajectory driven by strategic US market positioning.'
      }
    },
    
    // Data Sources
    // NOTE: Social data is fetched LIVE from backend /api/live-social/{profile_id}
    // DO NOT add mock social data here - use only verified data
    dataSources: {
      media: {
        mentionVolume: 12400,
        sentimentScore: 68,
        geographicReach: ['USA', 'UK', 'Argentina', 'Spain', 'France']
      },
      search: {
        googleTrends: 72,
        wikipediaViews: '45K/week'
      }
      // social: REMOVED - fetched from backend with verified data only
    },
    
    // Timestamp
    lastUpdated: '2025-01-13T10:30:00Z',
    dataConfidence: 'High'
  },
  
  perez: {
    id: 'perez',
    name: 'Jesús Pérez',
    role: 'Assistant Coach',
    organization: 'US Men\'s National Team',
    nationality: 'Spain',
    previousClubs: ['Tottenham Hotspur', 'Paris Saint-Germain', 'Chelsea'],
    // Profile photo - official asset
    photo: 'https://customer-assets.emergentagent.com/job_724875ab-121b-40d9-b670-59969cd98133/artifacts/uuy4kv70_jesus-perez.jpg',
    initials: 'JP',
    
    // Verified Social Profiles (URLs and handles only - follower counts fetched live)
    socialProfiles: {
      instagram: {
        url: 'https://www.instagram.com/jpp_71/',
        handle: '@jpp_71'
        // followers: FETCHED LIVE from backend - not mocked
      },
      twitter: {
        url: 'https://x.com/jesus_perez',
        handle: '@jesus_perez'
        // followers: FETCHED LIVE from backend - not mocked
      },
      linkedin: {
        url: 'https://www.linkedin.com/in/jesus-perez-1969a0295/',
        handle: 'Jesús Pérez'
        // followers: Never shown for LinkedIn
      }
    },
    
    // Core YBV Metrics
    metrics: {
      brandStrength: {
        score: 42,
        direction: 'stable',
        confidence: 'Medium',
        insight: 'Recognition primarily within soccer industry circles. Low public visibility but strong professional reputation.',
        components: {
          globalRecognition: 35,
          mediaPresence: 38,
          digitalFootprint: 28,
          narrativeControl: 67
        }
      },
      reputationStability: {
        score: 81,
        direction: 'up',
        confidence: 'High',
        insight: 'Exceptional stability due to consistent, low-profile professional approach. Minimal negative exposure.',
        components: {
          sentimentConsistency: 85,
          crisisResistance: 82,
          narrativeVolatility: 88,
          publicTrust: 69
        }
      },
      commercialAttractiveness: {
        score: 28,
        direction: 'stable',
        confidence: 'Low',
        insight: 'Limited individual commercial value. Value is primarily derived from professional association.',
        components: {
          sponsorAppeal: 24,
          marketDemand: 22,
          endorsementPotential: 18,
          mediaValue: 48
        }
      },
      riskExposure: {
        score: 18,
        direction: 'down',
        confidence: 'High',
        insight: 'Minimal risk exposure. Low public profile provides significant protection from scrutiny.',
        components: {
          performanceDependency: 25,
          mediaScrutiny: 12,
          contractVulnerability: 22,
          reputationalThreats: 13
        }
      },
      overallIndex: {
        score: 48,
        direction: 'stable',
        confidence: 'Medium',
        insight: 'Role-appropriate brand position. High stability compensates for lower visibility metrics.'
      }
    },
    
    // Data Sources
    // NOTE: Social data is fetched LIVE from backend /api/live-social/{profile_id}
    // DO NOT add mock social data here - use only verified data
    dataSources: {
      media: {
        mentionVolume: 890,
        sentimentScore: 72,
        geographicReach: ['USA', 'UK', 'Spain']
      },
      search: {
        googleTrends: 18,
        wikipediaViews: '2.1K/week'
      }
      // social: REMOVED - fetched from backend with verified data only
    },
    
    // Timestamp
    lastUpdated: '2025-01-13T10:30:00Z',
    dataConfidence: 'Medium'
  }
};

// Scenario simulation adjustments
export const scenarioAdjustments = {
  performanceShift: {
    positive: {
      brandStrength: 8,
      reputationStability: 5,
      commercialAttractiveness: 12,
      riskExposure: -5,
      overallIndex: 7
    },
    neutral: {
      brandStrength: 0,
      reputationStability: 0,
      commercialAttractiveness: 0,
      riskExposure: 0,
      overallIndex: 0
    },
    negative: {
      brandStrength: -6,
      reputationStability: -12,
      commercialAttractiveness: -8,
      riskExposure: 15,
      overallIndex: -8
    }
  },
  mediaPressure: {
    high: {
      brandStrength: 3,
      reputationStability: -8,
      commercialAttractiveness: 5,
      riskExposure: 12,
      overallIndex: -2
    },
    normal: {
      brandStrength: 0,
      reputationStability: 0,
      commercialAttractiveness: 0,
      riskExposure: 0,
      overallIndex: 0
    },
    low: {
      brandStrength: -2,
      reputationStability: 4,
      commercialAttractiveness: -3,
      riskExposure: -6,
      overallIndex: 1
    }
  },
  sponsorshipInterest: {
    high: {
      brandStrength: 5,
      reputationStability: 2,
      commercialAttractiveness: 15,
      riskExposure: 3,
      overallIndex: 6
    },
    normal: {
      brandStrength: 0,
      reputationStability: 0,
      commercialAttractiveness: 0,
      riskExposure: 0,
      overallIndex: 0
    },
    low: {
      brandStrength: -3,
      reputationStability: 1,
      commercialAttractiveness: -10,
      riskExposure: -2,
      overallIndex: -4
    }
  },
  marketFocus: {
    usa: {
      brandStrength: 0,
      reputationStability: 0,
      commercialAttractiveness: 0,
      riskExposure: 0,
      overallIndex: 0
    },
    europe: {
      brandStrength: -4,
      reputationStability: -3,
      commercialAttractiveness: -6,
      riskExposure: 3,
      overallIndex: -4
    },
    latam: {
      brandStrength: -2,
      reputationStability: 2,
      commercialAttractiveness: -7,
      riskExposure: -4,
      overallIndex: -2
    }
  }
};

// Insight templates based on metric levels
export const insightTemplates = {
  brandStrength: {
    high: 'Strong brand recognition creates significant market leverage and negotiating power.',
    medium: 'Moderate brand awareness provides a solid foundation for strategic positioning.',
    low: 'Limited public visibility suggests focus on professional rather than commercial development.'
  },
  reputationStability: {
    high: 'Exceptional reputation resilience provides protection against short-term volatility.',
    medium: 'Reasonable stability, though susceptible to significant performance or media events.',
    low: 'Elevated reputational sensitivity requires careful narrative management.'
  },
  commercialAttractiveness: {
    high: 'Premium commercial positioning with strong sponsor and endorsement potential.',
    medium: 'Solid commercial foundation with room for strategic value enhancement.',
    low: 'Commercial value primarily derived from role and association rather than individual appeal.'
  },
  riskExposure: {
    high: 'Elevated risk profile requires active monitoring and contingency planning.',
    medium: 'Manageable risk level with standard protective measures appropriate.',
    low: 'Low risk exposure provides operational flexibility and strategic optionality.'
  }
};
